function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#EDEDED",
  d: "M222.3,155.7H26.6c-4.1,0-7.3-3.3-7.3-7.3v-132c0-4.1,3.3-7.3,7.3-7.3h195.6c4.1,0,7.3,3.3,7.3,7.3v132 C229.6,152.4,226.3,155.7,222.3,155.7z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#DDDDDD",
  d: "M101,27.9H37.6c-1.8,0-3.3-1.5-3.3-3.3c0-1.8,1.5-3.3,3.3-3.3H101c1.8,0,3.3,1.5,3.3,3.3 C104.3,26.5,102.8,27.9,101,27.9z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M61,43.4H37.6c-1.8,0-3.3-1.5-3.3-3.3c0-1.8,1.5-3.3,3.3-3.3H61c1.8,0,3.3,1.5,3.3,3.3 C64.3,42,62.8,43.4,61,43.4z"
});

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#DDDDDD",
  d: "M212.8,35.1c-0.5,0-1-0.2-1.4-0.6l-10.3-10.3c-0.8-0.8-0.8-2,0-2.8s2-0.8,2.8,0l10.3,10.3c0.8,0.8,0.8,2,0,2.8 C213.8,34.9,213.3,35.1,212.8,35.1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DDDDDD",
  d: "M202.5,35.1c-0.5,0-1-0.2-1.4-0.6c-0.8-0.8-0.8-2,0-2.8l10.3-10.3c0.8-0.8,2-0.8,2.8,0s0.8,2,0,2.8l-10.3,10.3 C203.5,34.9,203,35.1,202.5,35.1z"
}));

var _ref6 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#DDD",
  strokeWidth: 5,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 124.4,
  y1: 51.9,
  x2: 124.4,
  y2: 133.5
});

var _ref7 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#DDD",
  strokeWidth: 5,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 218,
  y1: 92.7,
  x2: 30.9,
  y2: 92.7
});

var _ref8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#FFF",
  strokeWidth: 5,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  d: "M33,114.7c0,0,2.3,0,5.6-2"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#FFF",
  strokeWidth: 5,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "12.3016,12.3016",
  d: "M47.2,104c2.4-3.7,4.9-8.7,7-15.4C62,64.3,73.3,62.5,76.9,62.5c0.7,0,1.5,0,2.2,0c3.6,0,14.9,1.8,22.7,26.2 c8.4,26.1,21.2,26,21.2,26h2.8c0,0,12.4,0,21.2-26c9.3-27.5,23.8-26.1,23.8-26.1h0.7c0,0,14.9-0.9,23.8,26.1 c3.3,10.1,7.3,16.3,10.9,20.1"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#FFF",
  strokeWidth: 5,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  d: "M211,112.7c3.3,2,5.6,2,5.6,2"
})));

function SvgNoData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 248.9 164.6",
    style: {
      enableBackground: "new 0 0 248.9 164.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no-data.fce78a18.svg";
export { ForwardRef as ReactComponent };